import { ChatDescription } from './chatsType';
import { ClsItem } from './clsType';

export const FileTypes = {
  audio: 20,
  defaultFile: 100,
  image: 1,
  video: 30,
  voiceMessage: 21,
} as const;

export type MediaTypes = typeof FileTypes[keyof typeof FileTypes];

export const MimeTypeMap = {
  application: FileTypes.defaultFile,
  audio: FileTypes.audio,
  example: FileTypes.defaultFile,
  font: FileTypes.defaultFile,
  haptics: FileTypes.defaultFile,
  image: FileTypes.image,
  message: FileTypes.defaultFile,
  model: FileTypes.defaultFile,
  multipart: FileTypes.defaultFile,
  text: FileTypes.defaultFile,
  video: FileTypes.video,
  voiceMessage: FileTypes.voiceMessage,
} as const;

export type MimeTypeKeys = keyof typeof MimeTypeMap;
export type MimeTypeValues = typeof MimeTypeMap[MimeTypeKeys];

type contentType = `${MimeTypeKeys}/${string}`;

export type FileDescriptor = {
  contentType?: contentType;
  fileName: string;
  fileSize: number;
  fileType: MimeTypeValues;
  id: string;
  path: string;
};

export type FileItemType = {
  dialogId: ChatDescription['id'];
  file: FileDescriptor;
  messageId: number;
};

export type LinkItemType = {
  createdAt: string;
  dialogId: ChatDescription['id'];
  linkPreview?: {
    ['og:image']?: string;
    ['og:title']?: string;
    ['og:type']?: string;
    ['og:url']?: string;
  };
  mediaType: MediaTypes;
  text: string;
  messageId: number;
};

export type ObjFile = {
  id: string;
  name: string;
  fileName: string;
  title: string;
  dsc: string;
  cType: string;
  cTypeItem: ClsItem;
  cExtension: string;
  cExtensionItem: ClsItem;
  cMimeType: string;
  cMimeTypeItem: ClsItem;
};
